module.exports = __webpack_public_path__ + "static/img/4.5c0f59f3.jpg";